import { cn } from "../../../../lib/utils";
import { useScheduleContext } from "../hooks/context/useScheduleContext";
import { usePreferences } from "../../../Settings/Configuration/hooks/usePreferences";
import { useGroups } from "../../../Settings/General/OrganisationLevelGroups/context";
import { SCHEDULE_PREFERENCE_KEYS } from "../constants/scheduleTypes";
import { getSectionLevel } from "../helpers/eventdisplay/getSectionLevel";

type Level = { glSegment?: string; code?: string } | null | undefined;

interface SectionInfoProps {
    section?: any;
    payCode?: string | null;
    defaultLevel?: Level;
    className?: string;
}

function SectionInfo({ section, payCode, defaultLevel, className }: SectionInfoProps) {
    const { type } = useScheduleContext();
    const { allocatedGroups } = useGroups();
    const shiftDisplay = usePreferences(`${SCHEDULE_PREFERENCE_KEYS[type]}.shiftDisplay`);
    const hasSectionLevel = !!getSectionLevel([section]);

    const levels = (allocatedGroups ?? []).map((group: any, i: number) => {
        const key = group.level.replaceAll("_", "");
        if (!(shiftDisplay?.[key] ?? true)) return null;
        const level: Level = section?.[key] || (i === 0 && !hasSectionLevel ? defaultLevel : null);
        return level?.glSegment || level?.code;
    });

    const lines = [
        [
            (shiftDisplay?.job ?? true) && section?.job?.code,
            (shiftDisplay?.payCode ?? true) && (section?.payCode?.code || payCode),
        ],
        levels,
    ]
        .map((line) => line.filter(Boolean).join(" · "))
        .filter(Boolean);

    if (lines.length === 0) return null;

    return (
        <div className={cn("tw-flex tw-flex-col tw-min-w-0 tw-text-xs tw-leading-4 tw-text-neutral-600", className)}>
            {lines.map((line, i) => (
                <span key={i} className="tw-truncate">{line}</span>
            ))}
        </div>
    );
}

export default SectionInfo;
